export default function showActivitiesTimelinePopup(prefix) {
  const data = this.dataGet(prefix);
  this.dsClear();
  this.dsAdd("set","conf/popup/content","activitiesTimeline");
  this.dsAdd("set","conf/popup/data",data);
  this.dsAdd("set","conf/popup/show",true);
  this.dsProcess();
}
